export const basicTextGroupOverflowMenuLabel = "L$nwF";
export default {basicTextGroupOverflowMenuLabel};